module.exports = __webpack_public_path__ + "img/propbank-logo.c04a3972.png";